<template>
    <div class="col-span-full grid-cols-subgrid items-center min-w-0 flex justify-end gap-1 sm:col-span-1">
        <slot></slot>
    </div>
</template>
